import RemoteServiceURIs from '~/constants/RemoteServices';
import rollbar from '~/vendor/rollbar';

const checkResponseOkay = response => {
  return response.ok ? response : Promise.reject(response);
};

export function getSignalmanFeature(flagname, signalmanRoute) {
  return window
    .fetch(signalmanRoute)
    .then(checkResponseOkay)
    .then(response => response.json())
    .then(arr => arr[0])
    .catch(error => {
      rollbar.error('Signalman feature fetch error', error);
      return 'excluded';
    });
}

export function getSCSignalmanFeature(flagName) {
  const route = `${RemoteServiceURIs.profiles}/signalman_sc/features/${flagName}.json`;
  return getSignalmanFeature(flagName, route);
}

export function getProfilesSignalmanFeature(flagName) {
  const route = `${RemoteServiceURIs.profiles}/signalman/features/${flagName}.json`;
  return getSignalmanFeature(flagName, route);
}
